import { Button, Stack, Tooltip } from "@mui/material";
import { ReactNode } from "react";

interface Action {
  name: string;
  color?: "primary" | "secondary" | "error" | "success" | "info" | "warning";
  icon: ReactNode;
  onClick: () => void;
  disabled?: boolean;
  renderCondition?: boolean;
  tooltip?: string;
}

interface ContestApplicationActionsProps {
  actions: Action[];
}

export default function ApplicationActions({ actions }: ContestApplicationActionsProps) {
  return (
    <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap", gap: 1 }}>
      {actions
        .filter((action) => action.renderCondition !== false)
        .map((action, index) => {
          const button = (
            <Button
              key={index}
              variant="outlined"
              color={action.color}
              onClick={action.onClick}
              disabled={action.disabled}
              startIcon={action.icon}
              size="small"
              sx={{
                py: 1,
                px: 1.5,
                fontSize: "0.75rem",
                minWidth: 160,
                borderWidth: 2,
                fontWeight: 600,
                // Kolory zgodne z wytycznymi
                ...(action.color === "success" && {
                  color: "#10b981",
                  borderColor: "#10b981",
                  "&:hover": { backgroundColor: "#f1e7de", borderColor: "#10b981" },
                }),
                ...(action.color === "warning" && {
                  color: "#f59e0b",
                  borderColor: "#f59e0b",
                  "&:hover": { backgroundColor: "#f1e7de", borderColor: "#f59e0b" },
                }),
                ...(action.color === "primary" && {
                  color: "#6366f1",
                  borderColor: "#6366f1",
                  "&:hover": { backgroundColor: "#f1e7de", borderColor: "#6366f1" },
                }),
                "&:disabled": {
                  color: "#9ca3af",
                  borderColor: "#9ca3af",
                },
              }}
            >
              {action.name}
            </Button>
          );

          // Jeśli przycisk jest wyłączony i ma tooltip, opakuj w Tooltip
          if (action.disabled && action.tooltip) {
            return (
              <Tooltip key={index} title={action.tooltip} arrow>
                <span>{button}</span>
              </Tooltip>
            );
          }

          return button;
        })}
    </Stack>
  );
}
